<template>
<div class="box-labour">
    <div class="box-box">
        <div class="nav">
            <router-link to="AssetHome"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
            采购申请
            <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
        </div>
        <div class="issueContent">
            <div v-for="item in dataList1" :key="item.id">
                <p class="titleClass titleCotent">{{item.title}}</p>
                <img src="../../assets/you.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent(item.id)">
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            dataList1: [{
                    title: "1. OA采购申请流程 (固定资产适用)",
                    id: "21"
                },
                {
                    title: "2. 费控事前采购申请流程",
                    id: "23"
                }
            ],
        };
    },
    methods: {
        getOnPage(){
            this.$router.push({name: 'Search', params:{code:"222"}})
        },
        addGetContent(i) {
            if (i == 21) {
                this.$router.push({name: 'AssetFlow2',params: {code: "11"}});
            } else if (i == 22) {
                this.$router.push({name: 'AssetFlow2',params: {code: "12"}});
            } else if (i == 23) {
                this.$router.push({name: 'AssetFlow3',params: {code: "13"}});
            }
        },
    }
};
</script>

<style scoped>
.box-labour {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
}
.box-box {
    background: rgba(244, 244, 244, 1);
}
.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.issueContent {
    width: 90%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.3);
    border-radius: 10px;
    overflow: hidden;
}

.issueContent div {
    width: 100%;
    height: 56px;
    border-bottom: 1px solid #ededed;
}

.issueContent div:last-child {
    border-bottom: 0;
}

.issueContent div .titleClass {
    width: 86%;
    float: left;
    color: #838383;
    margin: 18px 0 18px 10px;
}

.issueContent div .ImgClassDian {
    width: 18px !important;
}

.issueContent div .titleCotent {
    width: 80% !important;
    margin-left: 24px !important;
    font-size: 15px;
}

.issueContent div img {
    width: 21px;
    float: right;
    margin: 18px 10px 18px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/assetflow/assetFlow.vue